import axios from 'axios';
import { CredentialRequest } from 'google-auth-library';

interface GoogleUserInfo {
  sub?: string;
  email?: string;
  email_verified?: boolean;
  name?: string;
  given_name?: string;
  family_name?: string;
  picture?: string;
}

interface FetchGoogleUserParams {
  accessToken: string;
}

interface ExchangeDesktopCodeToTokenParams {
  serverAuthCode: string;
  clientId: string;
  clientSecret?: string;
  redirectUri: string;
  codeVerifier: string;
}

export const fetchGoogleUser = async ({ accessToken }: FetchGoogleUserParams) => {
  const userInfoResponse = await axios.get('https://www.googleapis.com/oauth2/v3/userinfo', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  const user = userInfoResponse.data as GoogleUserInfo;
  return user;
};

export const exchangeDesktopCodeToToken = async ({
  serverAuthCode,
  clientId,
  clientSecret,
  redirectUri,
  codeVerifier,
}: ExchangeDesktopCodeToTokenParams) => {
  const body = new URLSearchParams({
    code: serverAuthCode,
    client_id: clientId,
    redirect_uri: redirectUri,
    grant_type: 'authorization_code',
    code_verifier: codeVerifier,
  });

  if (clientSecret) {
    body.set('client_secret', clientSecret);
  }

  const response = await axios.post('https://oauth2.googleapis.com/token', body.toString(), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });

  return response.data as CredentialRequest;
};
